export const getUpdatedPinCodeWithValue = (pinCode, index, newValue) =>
  pinCode.map((number, numberIndex) => ({
    value: index === numberIndex ? newValue : number.value
  }));

export default {
  getUpdatedPinCodeWithValue
};
